import React from 'react';
import styled from 'styled-components';
import { Tabs } from 'tdesign-react';
import TabPanel from 'tdesign-react/es/tabs/TabPanel';
import ListPanel from '@/components/ListPanel';
import { doBuried } from '@/services/buriedService';
import LogsTable from './LogsTable';
import OpenapiTable from './OpenApiLogsTable';

function Message() {
  const onChange = (val) => doBuried({ eventId: val });

  return (
    <ListPanel header='审计日志'>
      <Root>
        <Tabs defaultValue='PLATFORM_SYSTEM_AUDIT_LOG' onChange={onChange}>
          <TabPanel value='PLATFORM_SYSTEM_AUDIT_LOG' label='平台日志'>
            <LogsTable />
          </TabPanel>
          <TabPanel value='PLATFORM_OPENAPI_AUDIT_LOG' label='OpenAPI日志'>
            <OpenapiTable />
          </TabPanel>
        </Tabs>
      </Root>
    </ListPanel>
  );
}

export default Message;

const Root = styled.div`
  .t-tabs__nav-item.t-is-active {
    color: var(--td-brand-color);
  }
  .t-tabs__nav-item {
    color: var(--td-text-color-primary);
  }
`;
